import { render, staticRenderFns } from "./FormRenew.vue?vue&type=template&id=b4a9fe3c&"
import script from "./FormRenew.vue?vue&type=script&lang=js&"
export * from "./FormRenew.vue?vue&type=script&lang=js&"
import style0 from "./FormRenew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports